var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAndroid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.3947 1.61411L15.3679 16.3244M4.39475 22.3859L15.3679 7.67558M4 21.6996V2.30044C4.00491 1.70936 4.65441 1.2908 5.17604 1.61411L21.4851 11.3137C21.6051 11.3798 21.7055 11.4787 21.7754 11.5996C21.8454 11.7205 21.8824 11.8589 21.8824 12C21.8824 12.1411 21.8454 12.2795 21.7754 12.4004C21.7055 12.5213 21.6051 12.6201 21.4851 12.6864L5.17604 22.3859C4.65442 22.7091 4.00492 22.2907 4 21.6996Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/android.a73aa8ed7c65c189c0a5d82c94f025e8.svg";
export { ForwardRef as ReactComponent };